export default __webpack_public_path__ + "static/media/live-site.d77e4764.svg";